import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import IMetadata from '../../../../_interfaces/IMetadata';
import { ErrorsService } from '../../../../_services/errors/errors.service';
import { PatientsMetadataService } from '../../../../_services/patients/patients-metadata.service';
import { SessionService } from '../../../../_services/session/session.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  standalone: true,
  selector: 'app-create-metadata-text',
  templateUrl: './create-metadata-text.component.html',
  styleUrls: ['./create-metadata-text.component.scss'],
  imports: [
    FormsModule,
    TranslatePipe,

    ButtonModule,
    CommonModule,
    InputTextModule,
  ],
})
export class CreateMetadataTextComponent
  extends BaseComponent
  implements OnInit
{
  public metadata: IMetadata;
  public errors: {
    name: string;
    default: string;
  };

  constructor(
    public patientMetadataService: PatientsMetadataService,
    public messageService: MessageService,
    public errorsService: ErrorsService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session);
  }

  save() {
    this.patientMetadataService
      .create(this.customers_id, this.metadata)
      .subscribe({
        next: () => {
          this.clear();
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('MESSAGES.METADATA.CREATE.SUMMARY'),
            detail: this.translate.instant('MESSAGES.METADATA.CREATE.DETAIL'),
          });
        },
        error: (error) => {
          const code = this.errorsService.getMessageFromMetadataError(error);
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('MESSAGES.METADATA.ERROR.SUMMARY'),
            detail: this.translate.instant(`MESSAGES.METADATA.ERROR.${code}`),
          });
        },
      });
  }

  clear() {
    this.metadata = {
      customers_id: this.customers_id,
      metadata_types_id: 2,
      name: undefined,
      default: undefined,
    };

    this.errors = {
      name: undefined,
      default: undefined,
    };
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.clear();
  }
}
